import React from 'react';
import { MapPin, Route, Clock, Battery } from 'lucide-react';
import './BottomBar.css';

const StatBlock = ({ icon: Icon, label, value, unit, color }) => (
  <div className="stat-block fade-in">
    <div className="stat-block-icon" style={{ color }}>
      <Icon size={22} />
    </div>
    <div>
      <div className="stat-block-label">{label}</div>
      <div className="stat-block-value">
        <span style={{ color }}>{value}</span>
        {unit && <span className="stat-block-unit"> {unit}</span>}
      </div>
      <div className="stat-block-sub">
        {label === 'Patrols in Progress' && 'Active patrols'}
        {label === 'Distance Covered (Today)' && 'Across all units'}
        {label === 'Avg. Response Time' && 'Last 24 hours'}
        {label === 'Low Battery Batons' && 'Below 20%'}
      </div>
    </div>
  </div>
);

const BottomBar = ({ data }) => (
  <div className="bottom-bar">
    <StatBlock icon={MapPin} label="Patrols in Progress" value={data?.activePatrols || 1} color="#22c55e" />
    <StatBlock icon={Route} label="Distance Covered (Today)" value={(data?.totalDistanceToday || 100).toLocaleString()} unit="km" color="#3b82f6" />
    <StatBlock icon={Clock} label="Avg. Response Time" value={data?.avgResponseTime || '04:32'} unit="min" color="#f59e0b" />
    <StatBlock icon={Battery} label="Low Battery Batons" value={data?.lowBattery || 2} color="#ef4444" />
  </div>
);

export default BottomBar;
